import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';
import { ModalDeleteItemStyled } from './styles';

const ModalDeleteItem = ({
  isOpen,
  toggle,
  item,
  setItems,
  setStatus,
  onDelete,
  headerText,
  bodyText,
}) => {
  const { t: translate } = useTranslation();
  const [loading, setLoading] = useState(false);

  const deleteItem = async () => {
    setLoading(true);
    try {
      if (!item.isNew) {
        await onDelete();
      }
      setItems((prev) => prev.filter((col) => col.id !== item.id));
      setStatus('excluded');
      toggle();
    } catch (error) {
      console.error('Error deleting item:', error);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalDeleteItemStyled
      isOpen={isOpen}
      toggle={() => {
        if (!loading) toggle();
      }}
      centered
    >
      <ModalHeader
        toggle={() => {
          if (!loading) toggle();
        }}
      >
        {translate(headerText) || translate('Delete item')}
      </ModalHeader>
      <ModalBody>
        <div className="d-flex flex-column gap-3">
          <p>
            <Trans
              i18nKey={bodyText || 'Are you sure you want to delete the item {{item}}?'}
              values={{ item: item?.name }}
              components={{ strong: <span className="fw-bold" style={{ color: '#343A40' }} /> }}
            />
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="outline" onClick={toggle} disabled={loading === 'moving'} className="w-auto">
          {translate('Cancel')}
        </Button>
        <Button className="btn-submit" onClick={deleteItem} disabled={loading === 'deleting'}>
          {loading === 'deleting' ? (
            <i className="bx bx-loader-alt bx-spin" />
          ) : (
            translate('Exclude')
          )}
        </Button>
      </ModalFooter>
    </ModalDeleteItemStyled>
  );
};

ModalDeleteItem.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  item: PropTypes.object,
  setItems: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  bodyText: PropTypes.string,
};

export default ModalDeleteItem;
